import { Project } from "interfaces";

import { projectIsDriverAnalysis } from "flows/driver-analysis/interfaces";
import DriverAnalysisDataSummary from "flows/driver-analysis/elements/Data-File-Summary";

import { projectIsTimeSeriesAnalysis } from "flows/time-series/interfaces";
import TimeSeriesDataSummary from "flows/time-series/elements/Data-File-Summary";

import { projectIsClusteringAnalysis } from "flows/clustering/interfaces";
import ClusteringDataSummary from "flows/clustering/elements/Data-File-Summary";

import { projectIsNotebookAnalysis } from "flows/notebook-analysis/interfaces";
import NotebookAnalysisDataSummary from "flows/notebook-analysis/elements/Data-File-Summary";

import { projectIsTextMining } from "flows/text-mining/interfaces";
import TextMiningDataSummary from "flows/text-mining/elements/Data-File-Summary";

import { projectIsForecastingAnalysis } from "flows/forecasting/interfaces";
import ForecastingDataSummary from "flows/forecasting/elements/Data-File-Summary";

import { projectIsProfileDiscovery } from "flows/profile-discovery/interfaces";
import ProfileDiscoveryDataSummary from "flows/profile-discovery/elements/Data-File-Summary";

import { projectIsImpactAnalysisContinous } from "flows/impact-analysis-continous/interfaces";
import ImpactAnalysisContinousDataSummary from "flows/impact-analysis-continous/elements/Data-File-Summary";

import { projectIsImpactAnalysisBinary } from "flows/impact-analysis-binary/interfaces";
import ImpactAnalysisBinaryDataSummary from "flows/impact-analysis-binary/elements/Data-File-Summary";

import { projectIsMarketMixModelling } from "flows/market-mix-modelling/interfaces";
import MarketMixDataSummary from "flows/market-mix-modelling/elements/Data-File-Summary";

import { projectIsETAEstimator } from "flows/eta-estimator/interfaces";
import ETAProjectDataSummary from "flows/eta-estimator/elements/Data-File-Summary";

import { projectIsSalesEffectiveness } from "flows/sales-effectiveness/interfaces";
import SalesEffectivenessDataSummary from "flows/sales-effectiveness/elements/Data-File-Summary";

const DataFileSummary = ({ project }: { project: Project }) => {
  if (projectIsDriverAnalysis(project)) {
    return <DriverAnalysisDataSummary project={project} />;
  }

  if (projectIsSalesEffectiveness(project)) {
    return <SalesEffectivenessDataSummary project={project} />;
  }

  if (projectIsTimeSeriesAnalysis(project)) {
    return <TimeSeriesDataSummary project={project} />;
  }

  if (projectIsClusteringAnalysis(project)) {
    return <ClusteringDataSummary project={project} />;
  }

  if (projectIsNotebookAnalysis(project)) {
    return <NotebookAnalysisDataSummary project={project} />;
  }

  if (projectIsTextMining(project)) {
    return <TextMiningDataSummary project={project} />;
  }

  if (projectIsForecastingAnalysis(project)) {
    return <ForecastingDataSummary project={project} />;
  }

  if (projectIsProfileDiscovery(project)) {
    return <ProfileDiscoveryDataSummary project={project} />;
  }

  if (projectIsImpactAnalysisContinous(project)) {
    return <ImpactAnalysisContinousDataSummary project={project} />;
  }

  if (projectIsImpactAnalysisBinary(project)) {
    return <ImpactAnalysisBinaryDataSummary project={project} />;
  }

  if (projectIsMarketMixModelling(project)) {
    return <MarketMixDataSummary project={project} />;
  }

  if (projectIsETAEstimator(project)) {
    return <ETAProjectDataSummary project={project} />;
  }

  return null;
};

export default DataFileSummary;
